import * as types from "../actions/types/index";

const INITIAL_STATE = {
    isVisible:true
};
export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.HIDE_SEARCH_BAR:
            return {
                ...state,
                isVisible: action.isVisible
            };
        case types.SHOW_SEARCH_BAR:
            return {
                ...state,
                isVisible: action.isVisible
            };
        default:
            return {
                ...state
            }
    }
}